<!--
  ~ Copyright (c) 1999 - 2020 Accorto, Inc. - All rights reserved.
  -->

<section class="slds-container_center">

  <acc-global-header [appName]="appName"
                     [appTitle]="appTitle"></acc-global-header>
  <acc-global-navigation [localItems]="menuItems"
                         [fromSession]="false"
                         [localOnlyMain]="true"></acc-global-navigation>

  <main class="slds-m-around_small">

    <router-outlet></router-outlet>

  </main>

  <footer class="slds-m-horizontal_small">
    <small class="page-footer">
      <span id="page-url">{{footerUrl}}</span>
      <span id="page-status">{{footerStatus}}</span>
    </small>
  </footer>

  <acc-notification></acc-notification>

</section>
